import { FC } from 'react';

import type { ChatContextData } from '@eluve/api-contract';
import { Stack } from '@eluve/components';

import { ChatContextQuoteBlock } from './ChatContextQuoteBlock';

type UserMessageContextQuotesProps = {
  contexts: ChatContextData[] | undefined;
};

export const UserMessageContextQuotes: FC<UserMessageContextQuotesProps> = ({
  contexts,
}) => {
  if (!contexts?.length) return null;
  return (
    <>
      {contexts.map((ctx) => (
        <Stack key={ctx.id} direction="horizontal" justify="end">
          <div className="max-w-[80%]">
            <ChatContextQuoteBlock context={ctx} />
          </div>
        </Stack>
      ))}
    </>
  );
};
